'use strict';
module.exports = require('./auth-client.cjs.production.min.js')